import { useTheme } from "styled-components";
import { StyledTableWrapper } from "../../components/dataTable/main/DataTableStyles";
import InputWrapper from "../../components/input/wrapper/InputWrapper";
import { StyledInput } from "../../styles/InputStyles";
import { StyledFlexColumn, StyledFlexRow } from "../../styles/LayoutStyles";
import Checkbox from "../../components/input/checkbox/Checkbox";
import { useLanguageContext } from "../../context/LanguageContext";
import { useFrontofficeContext } from "../../context/FrontofficeContext";
import HiddenLoader from "../../components/loader/HiddenLoader/HiddenLoader";
import { StyledAltIconButton } from "../../styles/ButtonStyles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { useAuthContext } from "../../context/AuthContext";

function AttendanceListPageView({
  attendanceListData,
  onPresentChange,
  search,
  onSearchChange,
  onRefresh,
}) {
  const authContext = useAuthContext();
  const frontofficeContext = useFrontofficeContext();
  const { translate, translateEntity } = useLanguageContext();
  const theme = useTheme();

  return (
    <StyledFlexColumn style={{ gap: theme.spacing.large }}>
      <StyledFlexRow
        style={{ alignItems: "flex-end", justifyContent: "space-between" }}
      >
        {/* Search input */}
        <InputWrapper
          label={translate("eva.main.general.search")}
          style={{ width: "500px", maxWidth: "100%" }}
        >
          <StyledInput
            type="text"
            value={search}
            placeholder={translate("eva.main.general.search")}
            onChange={onSearchChange}
          />
        </InputWrapper>

        <StyledFlexRow style={{ alignItems: "center" }}>
          {/* Present info */}
          <p>{`${attendanceListData.present_count} / ${
            attendanceListData.record_count
          } ${translate(
            "eva.main.validation.attributes.attendance_present"
          )}`}</p>

          {/* Refresh button */}
          <HiddenLoader groups={"attendance_list_page_fetch"}>
            <StyledAltIconButton
              onClick={onRefresh}
              title={translate("eva.main.general.refresh")}
            >
              <FontAwesomeIcon icon={faRefresh} />
            </StyledAltIconButton>
          </HiddenLoader>
        </StyledFlexRow>
      </StyledFlexRow>

      {/* Visitors */}
      <StyledTableWrapper>
        <table>
          <thead>
            <tr>
              <th>
                {translate("eva.main.entities.visitor")} -{" "}
                {translate("eva.main.validation.attributes.name")}
              </th>

              <th>
                {translate("eva.main.validation.attributes.visitor_type_id")}
              </th>

              <th>{translate("eva.main.validation.attributes.employee_id")}</th>

              <th>{translate("eva.main.validation.attributes.location_id")}</th>

              <th style={{ width: 0 }}>
                {translate("eva.main.validation.attributes.attendance_present")}
              </th>
            </tr>
          </thead>

          <tbody>
            {attendanceListData.visitors.map((visitor) => (
              <tr key={visitor.id}>
                <td>
                  {frontofficeContext.getVisitorIdentifierString(visitor)}
                </td>

                <td>{translateEntity(visitor.visitor_type, "label")}</td>

                <td>{visitor.employee?.name}</td>

                <td>{authContext.mappedLocations?.[visitor.location]?.name}</td>

                <td>
                  <HiddenLoader
                    groups={[`attendance_list_page_visitors_${visitor.id}`]}
                  >
                    <Checkbox
                      value={visitor.attendance_present}
                      onChange={(val) =>
                        onPresentChange(visitor.id, "visitors", val)
                      }
                    />
                  </HiddenLoader>
                </td>
              </tr>
            ))}

            {attendanceListData.visitors.length === 0 && (
              <tr>
                <td colSpan={"100%"} style={{ textAlign: "center" }}>
                  {translate("eva.main.general.no_results")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </StyledTableWrapper>

      {/* Employees */}
      <StyledTableWrapper>
        <table>
          <thead>
            <tr>
              <th>
                {translate("eva.main.entities.employee")} -{" "}
                {translate("eva.main.validation.attributes.name")}
              </th>

              <th>{translate("eva.main.validation.attributes.location_id")}</th>

              <th style={{ width: 0 }}>
                {translate("eva.main.validation.attributes.attendance_present")}
              </th>
            </tr>
          </thead>

          <tbody>
            {attendanceListData.employees.map((employee) => (
              <tr key={employee.id}>
                <td>{employee.name}</td>

                <td>
                  {authContext.mappedLocations?.[employee.location]?.name}
                </td>

                <td>
                  <HiddenLoader
                    groups={[`attendance_list_page_employees_${employee.id}`]}
                  >
                    <Checkbox
                      value={employee.attendance_present}
                      onChange={(val) =>
                        onPresentChange(employee.id, "employees", val)
                      }
                    />
                  </HiddenLoader>
                </td>
              </tr>
            ))}

            {attendanceListData.employees.length === 0 && (
              <tr>
                <td colSpan={"100%"} style={{ textAlign: "center" }}>
                  {translate("eva.main.general.no_results")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </StyledTableWrapper>
    </StyledFlexColumn>
  );
}

export default AttendanceListPageView;
